import { Component, ElementRef, signal, viewChild } from "@angular/core";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

let nextTooltipID = 0;

@Component({
  selector: "wf-tooltip",
  standalone: true,
  imports: [
    FontAwesomeModule
  ],
  styleUrl: "tooltip.component.css",
  template: `
    <button
      class="tooltip-button"
      [style.anchor-name]="anchorName"
      [attr.aria-describedby]="tooltipID"
      (mousedown)="toggle()"
      (keydown.enter)="toggle()"
      (keydown.space)="toggle()"
      (focus)="open()"
      (blur)="close()"
      (document:keydown.escape)="close()"
    >
      <fa-icon [icon]="icon" size="lg"/>
    </button>
    <div
      #popoverRef
      id="{{ tooltipID }}"
      role="tooltip"
      class="tooltip-content"
      [style.display]="isOpen() ? 'block' : 'none'"
      [style.position-anchor]="anchorName"
    >
      <ng-content/>
    </div>
  `,
})
export class TooltipComponent {
  protected readonly icon = faCircleInfo;
  protected readonly tooltipID = `tooltip-${nextTooltipID++}`;
  protected readonly anchorName = `--anchor-${this.tooltipID}`;
  protected readonly isOpen = signal(false);

  // (mousedown) fires before focus instead of after like (click),
  // with (click), focus opens first then toggle would immediately close if
  // clicking from outside focus (which is the most common scenario)
  protected toggle() {
    this.isOpen.update(o => !o);
  }

  protected open() {
    this.isOpen.set(true);
  }

  protected close() {
    this.isOpen.set(false);
  }
}
